module.exports = __webpack_public_path__ + "vue_assets/img/img_header_background.2a93bb6c.jpg";